var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-title heading-3-bold",
    domProps: {
      "innerHTML": _vm._s(_vm.field.value.title)
    }
  }), _c('div', {
    staticClass: "info-column-wrapper"
  }, [_c('div', {
    staticClass: "info-column"
  }, [_c('div', {
    staticClass: "subtitle paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.field.value.text)
    }
  }), _c('seu-button', {
    attrs: {
      "label": _vm.field.value.buttonLabel,
      "button-icon-before": _vm.field.value.buttonIcon,
      "button-link": "https://www.google.com/maps?q=47.20113,8.78043",
      "target": "_blank"
    }
  })], 1), _c('div', {
    staticClass: "info-column right-column"
  }, [_c('div', {
    staticClass: "links-container"
  }, [_c('a', {
    staticClass: "info-row",
    attrs: {
      "href": "https://www.google.com/maps/place/Churerstrasse+54,+8808+Pf%C3%A4ffikon,+Switzerland/@47.2012196,8.7782759,17z/data=!3m1!4b1!4m6!3m5!1s0x479ab14d5cbde19f:0x9fe764032bac78e7!8m2!3d47.2012196!4d8.7804646!16s%2Fg%2F11c5k_0qw3"
    }
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('img', {
    staticClass: "info-asset",
    attrs: {
      "src": _vm.field.value.icon1,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.field.value.location)
    }
  })]), _c('a', {
    staticClass: "info-row",
    attrs: {
      "href": "tel:+41 (0)58 521 19 00"
    }
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('img', {
    staticClass: "info-asset",
    attrs: {
      "src": _vm.field.value.icon2,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.field.value.number)
    }
  })]), _c('a', {
    staticClass: "info-row",
    attrs: {
      "href": "https://www.seu.ch",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('img', {
    staticClass: "info-asset",
    attrs: {
      "src": _vm.field.value.icon3,
      "alt": ""
    }
  })]), _c('a', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.field.value.website)
    }
  })]), _c('a', {
    staticClass: "info-row",
    attrs: {
      "href": "mailto:info@seu.ch"
    }
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('img', {
    staticClass: "info-asset",
    attrs: {
      "src": _vm.field.value.icon4,
      "alt": ""
    }
  })]), _c('a', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.field.value.email)
    }
  })]), _c('a', {
    staticClass: "info-row",
    attrs: {
      "href": "https://www.linkedin.com/company/swiss-engineers-united"
    }
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('img', {
    staticClass: "info-asset",
    attrs: {
      "src": _vm.field.value.icon5,
      "alt": ""
    }
  })]), _c('span', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.field.value.linkedin)
    }
  })])]), _c('seu-button', {
    staticClass: "button-secondary",
    attrs: {
      "label": _vm.field.value.buttonLabel2,
      "button-icon-before": _vm.field.value.buttonIcon2,
      "target": "_blank"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('openPopup', 'ARRIVAL');
      }
    }
  })], 1)])]), _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('div', {
    directives: [{
      name: "scroll-animate",
      rawName: "v-scroll-animate"
    }],
    staticClass: "logo-box"
  }, [_vm._m(0)])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "logo-container"
  }, [_c('div', {
    staticClass: "asset-container"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/logo/seu-logo-name.svg"),
      "alt": ""
    }
  })])]);

}]

export { render, staticRenderFns }